import React, { useState, cloneElement, ReactElement } from "react";
import { IconButton, Menu, MenuItem } from "@mui/material";
import { ExpandMore } from "@mui/icons-material";
import { ButtonAction } from "shared/components/ButtonAction";
import { Link } from "react-router-dom";
import { accesRoles } from "shared/models";
import { useOpenPdf } from "shared/hooks/useOpenPdf";
import { Spinner } from "shared";

interface Props {
  children?: React.ReactNode;
}

export const MenuActions = ({ children }: Props) => {
  const { isLoading } = useOpenPdf();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const isOpenFunctions = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleMenuItemClick = () => {
    handleClose();
  };

  const childrenWithClose = React.Children.map(children, (child) => {
    if (React.isValidElement(child) && child.type === MenuItem) {
      return cloneElement(child as ReactElement, {
        onClick: handleMenuItemClick,
      });
    }
    return child;
  });

  return (
    <span className={"MenuFunctions"}>
      <IconButton data-testid={`buttonFunctions`} onClick={handleClick}>
        Acciones <ExpandMore />
      </IconButton>
      <Menu
        id="menu-options"
        data-testid="menuOptions"
        className={"menuOptions"}
        anchorEl={anchorEl}
        open={isOpenFunctions}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        marginThreshold={0}
        PaperProps={{
          style: {
            marginLeft: "-60px",
          },
        }}
      >
        {childrenWithClose}
        {isLoading && <Spinner />}
      </Menu>
    </span>
  );
};
